import EventBus from "core-ui/client/src/app/core/eventbus/EventBus";
import eventBusRun from "core-ui/client/src/app/core/eventbus/EventBusRun";
const eventBus = new EventBus(window, document);
eventBusRun(eventBus);

export default eventBus;
